import styled from "styled-components";

export const body = styled.body`
  margin: 0;
  height: 100svh;
`;

export const Box = styled.div`
  background-color: rgb(93, 74, 134);
  border-radius: 5px;
  padding: 10px 25px 10px 25px;
  animation: go-down 1s;
  @keyframes go-down {
    from {
      transform: translateY(-500px);
    }
    to {
      transform: translateX(0);
    }
  }

  @media screen and (max-height: 600px) {
    img {
      width: 120px;
    }
  }
`;

export const UnderLogoText = styled.h3`
  color: white;
  font-size: 16px;
  font-weight: 500;
  text-align: center;
`;
export const SmallText = styled.p`
  padding: 10px;
  color: white;
  font-size: 10px;
  text-align: center;
`;
export const InputLogin = styled.input`
  margin: 5px 0;
  padding: 10px;
  border-radius: 0;
`;

export const BtnResetPass = styled.button`
  align-content: center;
  display: flex;
  width: 100%;
  text-justify: center;
  padding: 10px;
  color: white;
  font-size: 10px;
  align-items: center;
  background: none;
  border: none;
`;
